import {createSvgIcon} from '../create-svg-icon';

export const MediationIcon = createSvgIcon(
  <path d="m18 16 4-4-4-4v3h-5.06C12.6 7.9 10.68 5.28 8 3.95 7.96 2.31 6.64 1 5 1 3.34 1 2 2.34 2 4s1.34 3 3 3c.95 0 1.78-.45 2.33-1.14C9.23 6.9 10.6 8.77 10.92 11h-3.1C7.4 9.84 6.3 9 5 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.3 0 2.4-.84 2.82-2h3.1c-.32 2.23-1.69 4.1-3.58 5.14C6.78 17.45 5.95 17 5 17c-1.66 0-3 1.34-3 3s1.34 3 3 3c1.64 0 2.96-1.31 2.99-2.95 2.68-1.33 4.6-3.95 4.94-7.05H18v3z" />
, 'MediationOutlined');
